import InvoicesGrid from './InvoicesGrid';

export default InvoicesGrid;
